import { style } from "@vanilla-extract/css";
import { borderRadius } from "@/client/ui/design-system/styles/border-radius.css";
import { colors } from "@/client/ui/design-system/styles/colors.css";
import { body3Css } from "@/client/ui/design-system/styles/typography.css";
import { px } from "@/client/utils/units";

export const tag = style({
    ...body3Css,
    fontSize: px(11),
    lineHeight: "1",
    fontWeight: 500,
    letterSpacing: px(0.4),
    textTransform: "uppercase",
    color: colors.gray30,
    backgroundColor: "transparent",
    borderWidth: px(1),
    borderStyle: "solid",
    borderColor: colors.gray60,
    borderRadius: borderRadius.pill,
    padding: `${px(5)} ${px(10)}`,
    margin: 0,
    flexShrink: 0,
    alignSelf: "center",
    cursor: "default",
});

export const tagInteractive = style({
    cursor: "pointer",
    transition: "border-color 0.12s ease, color 0.12s ease",
    ":hover": {
        borderColor: colors.gray40,
        color: colors.white,
    },
});

/** A forced preview is visually distinct so R&D never forgets it's on. */
export const tagPreviewing = style({
    borderColor: colors.purple30,
    color: colors.purple20,
});

export const tagHidden = style({
    visibility: "hidden",
});

export const label = style({
    color: "inherit",
});
